import React from 'react';
import { Hero } from '../components/Hero';
import { PromiseSection } from '../components/PromiseSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PainSection } from '../components/PainSection';
import { WhyFailsSection } from '../components/WhyFailsSection';
import { MechanismSection } from '../components/MechanismSection';
import { IncludesSection } from '../components/IncludesSection';
import { HowToUseSection } from '../components/HowToUseSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-white font-sans text-slate-900 selection:bg-yellow-200 selection:text-slate-900" data-id="element-302">
      <Hero data-id="element-303" />
      <PromiseSection data-id="element-304" />
      <ForWhomSection data-id="element-305" />
      <PainSection data-id="element-306" />
      <WhyFailsSection data-id="element-307" />
      <MechanismSection data-id="element-308" />
      <IncludesSection data-id="element-309" />
      <HowToUseSection data-id="element-310" />
      <ObjectionsSection data-id="element-311" />
      <CTASection data-id="element-312" />
      <Footer data-id="element-313" />
    </main>;
}